
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { WalletAttributesTabComponent } from 'src/app/components/wallet-alerts/wallet-attributes-tab/wallet-attributes-tab.component';
import { WalletEmailsTabComponent } from 'src/app/components/wallet-alerts/wallet-emails-tab/wallet-emails-tab.component';
import {
  ITab,
  TabControlComponent,
} from 'src/app/shared/components/tab-control/tab-control.component';
import { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';
import { WalletAttributesAlertConfigService } from '../services/wallet-attributes-alert-config.service';
import { WalletEmailAlertConfigService } from '../services/wallet-email-alert-config.service';
import { PageLoaderService } from 'src/app/services/page-loader.service';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { isAlert30DaysWallet } from 'src/app/helpers/plan-utils';

type WalletAttributesAlertConfigDialogProps = WalletResponseDto;

@Component({
  selector: 'app-wallet-attributes-alert-config-dialog',
  templateUrl: './wallet-attributes-alert-config-dialog.component.html',
  styleUrls: ['./wallet-attributes-alert-config-dialog.component.scss'],
  providers: [WalletEmailAlertConfigService, WalletAttributesAlertConfigService],
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    TabControlComponent,
    WalletAttributesTabComponent,
    WalletEmailsTabComponent,
    ConfirmationDialogComponent
],
})
export class WalletAttributesAlertConfigDialogComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @ViewChild('attributesTabContent') attributesTabContent!: TemplateRef<any>;
  @ViewChild('emailsTabContent') emailsTabContent!: TemplateRef<any>;

  tabs: ITab[] = [];
  wallet: WalletResponseDto;
  subscriptions: Subscription[] = [];

  get isAlert30Days(): boolean {
    return isAlert30DaysWallet(this.wallet?.planId);
  }

  get props(): ConfirmationDialogProps {
    return {
      title: $localize`:@@walletAlertsConfigurationTitle:Configuración de alertas de cartera`,
      cancelButton: {
        hide: true,
      },
    };
  }

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: WalletAttributesAlertConfigDialogProps,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly pageLoaderService: PageLoaderService,
    private readonly walletAttributesAlertConfigService: WalletAttributesAlertConfigService,
    private readonly walletEmailAlertConfigService: WalletEmailAlertConfigService,
  ) {
    this.wallet = this.data;
  }

  ngOnInit(): void {
    this.walletEmailAlertConfigService.fetchWalletEmails(this.wallet.id);

    this.walletAttributesAlertConfigService.fetchIndicators(
      this.wallet.id,
      this.wallet.planId,
      this.wallet.type,
    );

    this.subscriptions.push(
      this.walletAttributesAlertConfigService.getActionIsLoading$().subscribe((isLoading) => {
        this.pageLoaderService.setPageLoader(isLoading);
      }),
    );

    this.subscriptions.push(
      this.walletEmailAlertConfigService.getActionIsLoading$().subscribe((isLoading) => {
        this.pageLoaderService.setPageLoader(isLoading);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.tabs = [
      { label: 'Atributos', component: this.attributesTabContent },
      { label: 'E-mails', component: this.emailsTabContent },
    ];
    this.changeDetector.detectChanges();
  }

  get walletName() {
    return $localize`:@@Wallet:Cartera` + ` - ${this.wallet?.name}`;
  }
}
